import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Observable, of, timer } from "rxjs";
import { switchMap } from "rxjs/operators";

@Injectable()
export class CustomPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data["preload"]) {
      if (route.data["priority"]) {
        return timer(route.data["priority"] * 1000).pipe(switchMap(() => load()));
      }

      return of(null);
    } else {
      return of(null);
    }
  }
}
